module.exports = __webpack_public_path__ + "static/media/alarm-bell-badge.9dd2e40f.svg";